import { Link } from "react-router-dom";
import { articles } from "@/mocks/gossip";
import { formatCount } from "@/utils/format";

export default function HotSection() {
  const sorted = [...articles].sort((a, b) => b.hot - a.hot);
  const featured = sorted[0];
  const rest = sorted.slice(1, 6);

  return (
    <section id="hot" className="w-full">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 md:mb-12">
          <div>
            <span className="inline-flex items-center gap-2 text-xs md:text-sm text-primary-600 font-medium">
              <i className="ri-fire-line" />
              热门爆料
            </span>
            <h2 className="mt-2.5 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
              这两天大家都在看
            </h2>
          </div>
          <Link
            to="/channels"
            className="shrink-0 inline-flex items-center gap-2 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
          >
            浏览更多频道
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">
          <article className="lg:col-span-7 group rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors flex flex-col">
            <Link to={`/article/${featured.id}`} className="block cursor-pointer">
              <div className="relative w-full h-64 md:h-80 overflow-hidden bg-background-200">
                <img
                  src={featured.cover}
                  alt={`${featured.title}相关配图`}
                  title={`${featured.title} - 看料爆料`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-4 left-4 px-3 py-1 rounded-full text-xs bg-primary-500 text-background-50 whitespace-nowrap">
                  <i className="ri-fire-fill mr-1" />热度最高
                </span>
              </div>
            </Link>
            <div className="p-6 md:p-7 flex flex-col flex-1">
              <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-900 whitespace-nowrap">
                  {featured.channelName}
                </span>
                <span>{featured.date}</span>
                <span className="flex items-center gap-1"><i className="ri-eye-line" />{formatCount(featured.views)}</span>
              </div>
              <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 leading-snug">
                <Link to={`/article/${featured.id}`} className="hover:text-primary-600 transition-colors cursor-pointer">
                  {featured.title}
                </Link>
              </h3>
              <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{featured.summary}</p>
              <Link
                to={`/article/${featured.id}`}
                className="mt-auto pt-5 inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
              >
                阅读全文
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </article>

          <div className="lg:col-span-5 flex flex-col gap-4">
            {rest.map((item, index) => (
              <Link
                key={item.id}
                to={`/article/${item.id}`}
                className="group flex gap-4 p-3.5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <span className="w-10 h-10 shrink-0 rounded-md flex items-center justify-center font-heading font-bold text-lg bg-secondary-100 text-secondary-900">
                  {index + 2}
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500">
                    <span className="whitespace-nowrap">{item.channelName}</span>
                    <span className="flex items-center gap-1"><i className="ri-fire-line text-primary-500" />{formatCount(item.hot)}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}